import { driver } from 'driver.js';
import '../css/platform-driver.css';

document.addEventListener('livewire:initialized', () => {
  Livewire.hook('component.init', ({ component, cleanup }) => {
    if (
      component.name === 'platform.change-speed-modal' ||
      component.name === 'code-battle.modal.change-speed'
    ) {
      const speedSliderMobile = document.getElementById('speedSliderMobile');
      speedSliderMobile.value = window['stepSpeed'];
      let value =
        ((speedSliderMobile.value - speedSliderMobile.min) /
          (speedSliderMobile.max - speedSliderMobile.min)) *
        100;
      speedSliderMobile.style.background =
        'linear-gradient(to right, #27A0E4 0%, #27A0E4 ' +
        value +
        '%, #E3E3E3 ' +
        value +
        '%, #E3E3E3 100%)';
    } else if (
      component.name === 'platform.show-code-modal' ||
      component.name === 'code-battle.modal.show-code'
    ) {
      document.getElementById('blockly_python_code_container').innerHTML =
        window['blockly_python_code'] || '';
      if (component.name === 'code-battle.modal.show-code') {
        if (window['blockly_python_code']) {
          document
            .getElementById('codebattle-show-code-modal-empty-title')
            .classList.add('hidden');
          document
            .getElementById('codebattle-show-code-modal-empty-description')
            .classList.add('hidden');
          document
            .getElementById('codebattle-show-code-modal-empty-button')
            .classList.add('hidden');
          document
            .getElementById('codebattle-show-code-modal-code')
            .classList.remove('hidden');
          document
            .getElementById('codebattle-show-code-modal-code-description')
            .classList.remove('hidden');
          document
            .getElementById('codebattle-show-code-modal-code-button')
            .classList.remove('hidden');
        } else {
          document
            .getElementById('codebattle-show-code-modal-empty-title')
            .classList.remove('hidden');
          document
            .getElementById('codebattle-show-code-modal-empty-description')
            .classList.remove('hidden');
          document
            .getElementById('codebattle-show-code-modal-empty-button')
            .classList.remove('hidden');
          document
            .getElementById('codebattle-show-code-modal-code')
            .classList.add('hidden');
          document
            .getElementById('codebattle-show-code-modal-code-description')
            .classList.add('hidden');
          document
            .getElementById('codebattle-show-code-modal-code-button')
            .classList.add('hidden');
        }
      }
    } else if (component.name === 'platform.feedback-modal') {
      for (let i = 1; i <= 5; i++) {
        const feedbackRadio = document.getElementById('feedback-' + i);
        if (feedbackRadio.checked) {
          setTimeout(() => (feedbackRadio.checked = true));
        }
      }
    }
  });
});

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = document.cookie;
  try {
    decodedCookie = decodeURIComponent(document.cookie);
  } catch {}
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

const driverObj = driver();

driverObj.setConfig({
  stagePadding: 0,
  stageRadius: 8,
  onPopoverRender: (popover, { config, state }) => {
    const titleClone = popover.title.cloneNode(true);
    popover.title.remove();
    const closeButton = document.createElement('div');
    closeButton.className = 'cursor-pointer';
    closeButton.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 8L16 16" stroke="#131313" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M16 8L8 16" stroke="#131313" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;
    const header = document.createElement('div');
    header.className = 'flex justify-between';
    header.appendChild(titleClone);
    header.appendChild(closeButton);
    popover.wrapper.prepend(header);
    closeButton.onclick = function () {
      driverObj.destroy();
    };
  },
  onDestroyed: (element, step, { config, state }) => {
    setCookie('platform-tour-login', true, 1);
  },
});

if (
  (window.showProjectPopover || false) &&
  !getCookie('project-popover-shown')
) {
  setCookie('project-popover-shown', 1, 365);
  driverObj.highlight({
    element: '#add-to-gallery-button',
    popover: {
      title: window.tourTexts.addToGalleryTitle,
      description: window.tourTexts.addToGalleryDescription,
      side: 'top',
    },
  });
}
